export { PDPPromoText } from './PDPPromoText';
